import {RequestInfo} from "@repo/shared-core";

const PARTITIONED_SUBDOMAIN = "partitioned";
const SUPPORTED_SUBDOMAINS = [
    "", // account for the root domain
    "www",
    "en",
    "es",
    "hi",
    "pt-pt",
    "pt",
    PARTITIONED_SUBDOMAIN,
]; // When updating this list, also update Azure AD app redirect URIs.  See https://khanacademy.atlassian.net/wiki/spaces/CLASS/pages/3441262597/Microsoft+OneDrive for more details.

/**
 * Returns the redirect uri confgiured in the Azure AD app registration based
 * on the hostname.
 *
 * @param hostname hostname of the current request
 * @returns the redirect uri based on the hostname
 */
export const getRedirectUri = (hostname: string) => {
    const hostLower = hostname.toLowerCase();
    const subdomain = hostLower.substring(
        0,
        hostLower.lastIndexOf(".khanacademy."),
    );
    if (
        (hostLower.endsWith("khanacademy.org") ||
            hostLower.endsWith("khanacademy.dev")) &&
        SUPPORTED_SUBDOMAINS.includes(subdomain)
    ) {
        if (subdomain === PARTITIONED_SUBDOMAIN) {
            // use a login url to avoid the redirect logic for the partitioned subdomain
            return `https://${hostname}/login`;
        }
        return `https://${hostname}/`;
    }
    return "http://localhost:8090/";
};

const PROD_MS_CLIENT_ID = "c4148f83-6c65-49b7-86dc-2eef56a73a12";
const DEV_MS_CLIENT_ID = "86c7427f-0fad-497d-ac8a-f92e4ca497ce";

/*
 * Returns the appropriate Microsoft Graph API client ID based on the environment.
 *
 * @returns the Microsoft Graph API client ID
 */
export const getClientId = (): string => {
    return RequestInfo.IS_DEV_SERVER ? DEV_MS_CLIENT_ID : PROD_MS_CLIENT_ID;
};
